/**
 * @param {number} a
 * @param {number} b
 * @return {number[]}
 */
export const makeRange = (a, b) => {
  const range = [];

  for (let i = a; i <= b; i++) {
    range.push(i);
  }

  return range;
};

/**
 * @param {string} pageNumber
 * @return {number|null|NaN}
 */
const parsePageNumber = (pageNumber) => {
  pageNumber = pageNumber.trim();

  if (pageNumber === '') {
    return null;
  }

  return parseInt(pageNumber, 10);
};

/**
 * @param {string} pageRange
 * @param {number} numPages
 * @return {number[]}
 */
export const parsePageRange = (pageRange, numPages) => {
  const pages = [];
  const splitPageRange = pageRange.split(',');

  for (let i = 0; i < splitPageRange.length; ++i) {
    const range = splitPageRange[i].split('-');

    if (range.length === 1 && range[0]) {
      const a = parsePageNumber(range[0]);

      if (a && a <= numPages) {
        pages.push(a);
      }
    } else if (range.length === 2) {
      let a = parsePageNumber(range[0]);
      let b = parsePageNumber(range[1]);

      if (!isNaN(a) && !isNaN(b) && (a || b) && a <= numPages && b !== 0 && a <= (b || numPages)) {
        if (!a) {
          a = 1;
        }

        if (!b || b > numPages) {
          b = numPages;
        }

        for (let j = a; j <= b; ++j) {
          pages.push(j);
        }
      }
    }
  }

  return [...new Set(pages)].sort((a, b) => a - b);
};

/**
 * @param {number[]} pages
 * @param {string} [separator]
 * @return {string}
 */
export const stringifyPageRange = (pages, separator = ', ') => {
  const ranges = [];
  let start = null;

  for (let i = 0; i < pages.length; i++) {
    if (pages[i] + 1 === pages[i + 1]) {
      if (start === null) {
        start = i;
      }
    } else {
      if (start === null) {
        ranges.push([pages[i]]);
      } else {
        ranges.push([pages[start], pages[i]]);
        start = null;
      }
    }
  }

  return ranges.map((range) => range.join('-')).join(separator);
};

/**
 * @param {number[]} pages
 * @return {{angle: number, range: string}[]}
 */
export const rotationPageRanges = (pages) => {
  const angles = {};

  for (let i = 0; i < pages.length; i++) {
    const pageNumber = i + 1;
    const angle = pages[i];

    if (angle) {
      if (!angles[angle]) {
        angles[angle] = [];
      }

      angles[angle].push(pageNumber);
    }
  }

  return Object.entries(angles)
    .map(([angle, pages]) => ({
      angle: parseInt(angle, 10),
      range: stringifyPageRange(pages),
    }));
};

/**
 * @param {number[]} pageRange
 * @param {number[]} fileNumPage
 * @return {number[][]}
 */
export const chunkPageRange = (pageRange, fileNumPage) => {
  const chunkedPageRange = [];
  let numPageSum = 0;
  let startPageIndex = 0;

  for (let fileIndex = 0; fileIndex < fileNumPage.length; fileIndex++) {
    const filePageRange = [];
    const numPage = fileNumPage[fileIndex];
    const absMinPageNumber = numPageSum + 1;
    const absMaxPageNumber = numPageSum + numPage;

    for (let i = startPageIndex; i < pageRange.length; i++) {
      const absPageNumber = pageRange[i];

      if (absMinPageNumber <= absPageNumber && absPageNumber <= absMaxPageNumber) {
        filePageRange.push(absPageNumber - numPageSum);
        startPageIndex = i + 1;
      }
    }

    chunkedPageRange.push(filePageRange);
    numPageSum += numPage;
  }

  return chunkedPageRange;
};

/**
 * @param {number[][]} chunkedPageRange
 * @param {number[]} fileNumPage
 * @return {number[]}
 */
export const flatChunkedPageRange = (chunkedPageRange, fileNumPage) => {
  const pageRange = [];
  let numPageSum = 0;

  for (let fileIndex = 0; fileIndex < chunkedPageRange.length; fileIndex++) {
    const filePageRange = chunkedPageRange[fileIndex];
    const numPage = fileNumPage[fileIndex];

    for (let i = 0; i < filePageRange.length; i++) {
      const pageNumber = filePageRange[i];

      pageRange.push(numPageSum + pageNumber);
    }

    numPageSum += numPage;
  }

  return pageRange;
};
